import type { FC } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "@privacy/translations";
import { HACK_alignIconWithLabelBox } from "@privacy/ui";
import { ChevronDownIcon, PlusIcon, SparklesIcon } from "../../shared/icons";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import type { AssistantStartState } from "../../shared/assistantAccess";
import { CreateRegistrationDialog } from "./CreateRegistrationDialog";

type CreateRegistrationMenuButtonProps = { onCreated: (id: string) => void };

export const CreateRegistrationMenuButton: FC<CreateRegistrationMenuButtonProps> = ({ onCreated }) => {
  const { t } = useTranslation();
  const { navigate, paths } = usePrivacyNavigate();
  const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const closeMenu = () => setButtonRef(null);

  return (
    <>
      <Button
        sx={{ textWrap: "nowrap" }}
        startIcon={<PlusIcon size={14} />}
        endIcon={<ChevronDownIcon size={14} />}
        onClick={event => setButtonRef(event.currentTarget)}
      >
        <HACK_alignIconWithLabelBox>{t("CreateRegistration.Button")}</HACK_alignIconWithLabelBox>
      </Button>
      <Menu anchorEl={buttonRef} open={Boolean(buttonRef)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            closeMenu();
            setIsDialogOpen(true);
          }}
        >
          <PlusIcon />
          {t("CreateRegistration.Menu.Manually")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            closeMenu();
            const state: AssistantStartState = { startsRegistration: true };
            navigate(paths.assistantNew(), { state });
          }}
        >
          <SparklesIcon />
          {t("CreateRegistration.Menu.WithAssistant")}
        </MenuItem>
      </Menu>
      {isDialogOpen && <CreateRegistrationDialog onClose={() => setIsDialogOpen(false)} onCreated={onCreated} />}
    </>
  );
};
